// extracted by mini-css-extract-plugin
export default {"cta_area":"Cta_cta_area__Q7ohQ","btn_wrapper":"Cta_btn_wrapper__7eX+y"};